module.exports = __webpack_public_path__ + "img/card-lines-ver.3e7b9755.svg";